import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hooks';
import { detailColumns } from './detailColumns';

export const OrderedLicenses: React.FC = () => {
  const { orderedLicenses } = useAppSelector(
    (state) => state.licenseContent.data
  );
  const { t } = useTranslation();

  return (
    <>
      <Row className="d-flex justify-content-between">
        <Col md={2}>
          <small className="ml-2 mb-2 fs-10 font-weight-bold">
            {Object.keys(orderedLicenses).length} {t('licenseContent.licenses')}
          </small>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col>
          <div className="div-border">
            <BootstrapTable
              keyField="code"
              data={orderedLicenses}
              columns={detailColumns}
              wrapperClasses="table-license-content table-wrapper"
            />
          </div>
        </Col>
      </Row>
    </>
  );
};
